export default __webpack_public_path__ + "static/media/team-img-1.ba057a00.webp";